import { atom, ReadWriteSelectorOptions, selector } from "recoil";


/**
 * Recoil state handling stepper index
 * 
 */
export const StepIndexAtom = atom<number>({
    key: 'state.Stepper.StepIndexAtom',
    default: 0
});


export const StepIndex = selector<number>({
    key: 'state.Stepper.StepIndex',
    get: ({ get }) => {
        const stepIndexAtom = get(StepIndexAtom)
        return stepIndexAtom
    },
    set: ({ set, get }, newValue: number) => {
        const stepIndexUnlocked = get(StepIndexUnlocked)
        if (newValue <= stepIndexUnlocked) {
            return set(StepIndexAtom, newValue)
        }
        return get(StepIndexAtom)
    }
} as ReadWriteSelectorOptions<number>)

export const StepIndexUnlocked = atom<number>({
    key: 'state.Stepper.StepIndexUnlocked',
    default: 0
});

export const StepIndexSubmiting = atom<number | undefined>({
    key: 'state.Stepper.Index.Submiting',
    default: undefined
});

/**
 * Use to store value as global value accross steps
 */
export const StepperStore = atom<Record<string, any>>({
    key: 'state.Stepper.StepperStore',
    default: {}
});
